module.exports = __webpack_public_path__ + "img/2-2.3e7cfe1e.svg";